module.exports = __webpack_public_path__ + "static/media/tutorial.ab4a0387.png";